import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class EstudioSocioeconomicoService {
  private ruta = "/php/estudio-socioeconomico-service.php";
  private endpoint = "";
  constructor(private _http:HttpClient, private _configService:ConfigurationService) {
    this.endpoint = this._configService.getConfiguration().hostapi;
  }

  find(nombre:string,nivel:string,grado:string,indice:number,registros:number):Observable<any>{
    return this._http.get(this.endpoint+this.ruta+"?opc=find&nombre="+nombre+"&nivel="+nivel+"&grado="+grado+"&i="+indice+"&r="+registros);
    // return this._http.get("http://localhost/ng-san-juan-pablo/php/estudio-socioeconomico-service.php?opc=find&nombre="+nombre+"&nivel="+nivel+"&grado="+grado+"&i="+indice+"&r="+registros);
  }
  update(json:any):Observable<any>{
    return this._http.post(this.endpoint+this.ruta+"?opc=modifica",json);
  }
  findByKey(idAlumno:number, idCiclo:number, idNivel:number, idGrado:number):Observable<any>{
    return this._http.get(this.endpoint+this.ruta+"?opc=findByKey&idAlumno="+idAlumno+"&ciclo="+idCiclo+"&nivel="+idNivel+"&grado="+idGrado)
    // return this._http.get("http://localhost/ng-san-juan-pablo/php/estudio-socioeconomico-service.php?opc=findByKey&idAlumno="+idAlumno+"&ciclo="+idCiclo+"&nivel="+idNivel+"&grado="+idGrado)
  }
  traduceEstatus(id){
    if(id==3){
      return "Concluido";
    }else if(id==2){
      return "En proceso";
    }else{
      return "Sin iniciar";
    }

  }
  
}
